import { render, staticRenderFns } from "./OsCustomerForm.vue?vue&type=template&id=5d546ef0&scoped=true"
import script from "./OsCustomerForm.vue?vue&type=script&lang=ts"
export * from "./OsCustomerForm.vue?vue&type=script&lang=ts"
import style0 from "./OsCustomerForm.vue?vue&type=style&index=0&id=5d546ef0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d546ef0",
  null
  
)

export default component.exports